import styled from 'styled-components';
import { Stack } from '@mui/material';
import SelectedConversationMessageList from './SelectedConversationMessageList';
import { useGetTwilioConversationById } from '@vs-online-only-app/state';

import MessageComposer from '../message-composer/MessageComposer';
import SelectedConversationShopperProfile from './SelectedConversationShopperProfile';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';
import SelectedActiveConversationHeader from './SelectedActiveConversationHeader';
import { SelectedArchivedConversationHeader } from './SelectedArchivedConversationHeader';
import SmartResponses from './smart-responses/SmartResponses';

const SectionWrapper = styled.div`
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: auto 1fr;
  overflow: auto;
`;

const LiveChatWrapper = styled(Stack)`
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 3, 4, 3)};
  overflow: auto;
  box-sizing: border-box;
  position: relative;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const SelectedConversationSection = () => {
  const selectedHeroConversation = useSelectedHeroConversation();
  const { data: selectedTwilioConversation } = useGetTwilioConversationById(
    selectedHeroConversation?.twilioConversationId
  );

  if (
    !selectedHeroConversation ||
    selectedTwilioConversation?.status !== 'joined'
  ) {
    return null;
  }

  return (
    <SectionWrapper>
      {selectedHeroConversation.archiveAttributes ? (
        <SelectedArchivedConversationHeader />
      ) : (
        <SelectedActiveConversationHeader />
      )}
      <LiveChatWrapper>
        <SelectedConversationMessageList />
        <SmartResponses />
        {!selectedHeroConversation.archiveAttributes && <MessageComposer />}
      </LiveChatWrapper>
      <SelectedConversationShopperProfile />
    </SectionWrapper>
  );
};
export default SelectedConversationSection;
